<template>
  <Subcard class="SubcardReservationSmall">
    <Route :id="reservation.id" to="AdminReservation">
      <Row>
        <Column :md="6">
          <Set name="Parkas">
            {{ project.name }}
          </Set>
        </Column>
        <Column :md="6">
          <Set name="Galingumas">
            {{ reservation.capacity | kw }}
          </Set>
        </Column>
      </Row>
    </Route>
  </Subcard>
</template>

<script>
import Set from '../Set'
import Subcard from './Subcard'
import { getters } from 'views/utils'

export default {
  components: { Set, Subcard },
  props: {
    reservation: Object,
  },
  computed: {
    project() {
      return this.query('project', this.reservation.projectId)
    },
    user() {
      return this.query('user', this.reservation.userId)
    },
    ...getters('getPaymentStatus', 'getPaymentType', 'getReservationUnpaidPayment'),
  },
}
</script>

<style lang="scss">
.SubcardReservationSmall {
  background: $grey-lightest;
  border-radius: 15px 0;

  &:hover {
    background: $grey-lighter;
  }
}
</style>
